/*
 *
 * App constants
 *
 */

const constantKey = 'app/containers/App';

const appConstants = {
  DEFAULT_ACTION: `${constantKey}/DEFAULT_ACTION`,
  DEFAULT_ACTION_SUCCESS: `${constantKey}/DEFAULT_ACTION_SUCCESS`,
  DEFAULT_ACTION_ERROR: `${constantKey}/DEFAULT_ACTION_ERROR`,

  TOGGLE_THEME: `${constantKey}/TOGGLE_THEME`,
  SET_APP_LOADED: `${constantKey}/SET_APP_LOADED`,
  UPDATE_TOKEN: `${constantKey}/UPDATE_TOKEN`,
  
  LOGOUT_REQUEST: `${constantKey}/LOGOUT_REQUEST`,
  LOGOUT_SUCCESS: `${constantKey}/LOGOUT_SUCCESS`,
  LOGOUT_ERROR: `${constantKey}/LOGOUT_ERROR`,
  
  CLEAR_SESSION: `${constantKey}/CLEAR_SESSION`,
  
  CHANGE_LANGUAGE: `${constantKey}/CHANGE_LANGUAGE`,
  SAVE_LANGUAGE_PREFERENCE: `${constantKey}/SAVE_LANGUAGE_PREFERENCE`,
  SAVE_LANGUAGE_PREFERENCE_SUCCESS: `${constantKey}/SAVE_LANGUAGE_PREFERENCE_SUCCESS`,
  SAVE_LANGUAGE_PREFERENCE_ERROR: `${constantKey}/SAVE_LANGUAGE_PREFERENCE_ERROR`,
};

export default appConstants;
